
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { AccountDataSourceService } from '../../../services/account-data-source.service';
import { projectConstants } from 'src/app/shared/constants/project-constants';

@Component({
  selector: 'app-analytics-filter',
  templateUrl: './analytics-filter.component.html',
  styleUrls: ['./analytics-filter.component.css'],
})
export class AnalyticsFilterComponent implements OnInit, OnDestroy {
  account_filter = {'metricId': null,'fromDate': null,'toDate': null,'frequency': 'DAILY','accId': null }
  user_filter={'userId':null,'metricId': null,'fromDate': null,'toDate': null,'frequency': 'DAILY','accId': null}
  dept_label={'deptId':null,'metricId': null,'fromDate': null,'toDate': null,'frequency': 'DAILY','accId': null}
  team_filter={'teamId':null,'metricId': null,'fromDate': null,'toDate': null,'frequency': 'DAILY','accId': null}
  domain_filter={'domainId':null,'metricId': null,'fromDate': null,'toDate': null,'frequency': 'DAILY'}
  subdomain_filter={'domainId':null,'subdomainId':null,'metricId': null,'fromDate': null,'toDate': null,'frequency': 'DAILY'}
  collapsedUserLevel:boolean=false;
  teamCollapsed=false;
  domainCollapsed=false;
  subdomainCollapsed=false;
  collapsedDept = false;
  collapsed = false;
  screenHeight;
  screenWidth;
  small_device_display = false;
  analyticsInfo: any;
  public dataSource:any;
  metricList: any = [];
  // public displayedCoulmns:string=[]
  constructor(private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private accountDataSourceService: AccountDataSourceService
  ) {
    this.onResize();
  }

  ngOnInit() {
    this.accountService.getAnalyticsMetricsList().subscribe(
      (metrics: any)=> {
        this.metricList = metrics;
      }
    )
  }

  generateAccountFilter(label) {
    let filterObj;
    switch(label) {
      case 'account':
        filterObj = this.account_filter;
        break;
      case 'user':
        filterObj = this.user_filter;
        break;
      case 'dept': 
        filterObj = this.dept_label;
        break;
      case 'team':
        filterObj = this.team_filter;
        break;
      case 'domain':
        filterObj = this.domain_filter;
        break;
      case 'subdomain': 
        filterObj = this.subdomain_filter;
        break;
    }
    let filterString = '';
    if (filterObj.metricId) {
      filterString += 'metricId='+ filterObj.metricId;
      console.log(filterString)
    }
    if (this.account_filter.toDate) {
      if (filterString !== '') {
        filterString += '&'
      }
      filterString += 'dateTo='+ filterObj.toDate;
      console.log(filterString)
    }
    if (filterObj.fromDate) {
      if (filterString !== '') {
        filterString += '&'
      }
      filterString += 'dateFrom='+ filterObj.fromDate;
      console.log(filterString)
    }
    if (filterObj.frequency) {
      if (filterString !== '') {
        filterString += '&'
      }
      filterString += 'frequency='+ filterObj.frequency;
      console.log(filterString)
    }
    if (filterObj.accId) {
      if (filterString !== '') {
        filterString += '&'
      }
      filterString += 'accId='+ filterObj.accId;
      console.log(filterString)
    }
    if (filterObj.teamId) {
      if (filterString !== '') {
        filterString += '&'
      }
      filterString += 'teamId='+ filterObj.teamId;
      console.log(filterString)
    }
    if (filterObj.domainId) {
      if (filterString !== '') {
        filterString += '&'
      }
      filterString += 'domainId='+ filterObj.domainId;
      console.log(filterString)
    }
    if (filterObj.subDomainId) {
      if (filterString !== '') {
        filterString += '&'
      }
      filterString += 'subDomainId='+ filterObj.subdomainId;
      console.log(filterString)
    }
    return filterString;
  }

  generateAnalyticsInfo (labelName) {
      const accountFilters = this.generateAccountFilter(labelName);
      console.log("Filter:", accountFilters);
      this.accountService.getAnalytics(labelName, accountFilters).subscribe(
        (analyticsInfo: any) => {
          console.log("Analytics info : ",analyticsInfo);
          this.accountService.storeAnalyticsInfo(analyticsInfo);
          this.accountDataSourceService.setAnalyticsInfo(analyticsInfo);
          this.router.navigate(['list'], { relativeTo: this.route });
        }, (error)=>{
          console.log(error);
        }
      );
  }
  
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
  ngOnDestroy() {
    this.resetDateFitlerParams();

  }
  clearAccountFilters () {

  }
  resetDateFitlerParams() {
  }
  
  showMoreFilter() {
  }

}
